import { createReducer, on } from "@ngrx/store";
import { eKioskError } from "src/app/shared/models/api/constants";
import { ErrorLevel } from "../error-level";
import { resetError, setErrorMsg } from "./error.actions";

export const errorFeatureKey = "error";

export interface ErrorState {
	errorMsg: string;
	noTranslation: boolean;
	displayCountdown: boolean;
	errorLevel: ErrorLevel;
	kioskError: eKioskError;
}

export const initialState: ErrorState = {
	errorMsg: undefined,
	noTranslation: undefined,
	displayCountdown: undefined,
	errorLevel: ErrorLevel.ERROR,
	kioskError: undefined,
};

export const errorReducer = createReducer(
	initialState,
	on(setErrorMsg, (state, { data,errorLevel, noTranslation, displayCountdown, KioskError }) => ({
		...state,
		errorMsg: (data == null && KioskError != null)? eKioskError[KioskError]: data,
		noTranslation: noTranslation,
		displayCountdown: displayCountdown,
		errorLevel: errorLevel,
		kioskError: KioskError,
	})),
	on(resetError, () => initialState)

);
